import React from "react";
import { Linkedin, Instagram, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#1a2035] text-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top section: Logo + CTA and Badges */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8">
          {/* Logo & CTA */}
          <div>
            <img
              src="/lovable-uploads/0174e7d3-9a04-4db3-b808-8ef7469fc5a8.png"
              alt="Naboo"
              width="140"
              height="44"
              loading="lazy"
              className="h-10 mb-2"
              onError={(e) => {
                console.warn("Impossible de charger le logo du pied de page");
                e.currentTarget.style.display = "none";
              }}
            />
            <p className="text-[#C6E278] text-sm font-medium">À quand votre prochain événement ?</p>
          </div>

          {/* Certification Badges */}
          <div className="flex items-center gap-4">
            <img
              src="/lovable-uploads/certification-badges.png"
              alt="Certifications EcoVadis Bronze Top 35%, ACORP et AICPA SOC"
              className="h-12 md:h-14 w-auto object-contain mix-blend-lighten"
              loading="lazy"
            />
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 my-6" />

        {/* Bottom section: Legal + Social */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 text-sm text-gray-300">
            <span className="text-white font-medium">© SAS NABOO GROUP 2026</span>
            <a
              href="https://www.naboo.app/en-us/privacy-policy?utm_source=landing_page_fr&utm_medium=referral&utm_campaign=footer_link"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Mentions légales & Politique de confidentialité
            </a>
            <a
              href="https://www.naboo.app/en-us/terms-of-use?utm_source=landing_page_fr&utm_medium=referral&utm_campaign=footer_link"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Conditions générales d'utilisation
            </a>
            <a
              href="javascript:openAxeptioCookies()"
              className="hover:text-white transition-colors cursor-pointer"
            >
              Mes préférences cookies
            </a>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.linkedin.com/company/naboo-app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://www.instagram.com/naboo.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              href="mailto:hello@naboo.app"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="Email"
            >
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
